export default __webpack_public_path__ + "static/media/9R.616afbce.png";